export var TRIGGER = 'TRIGGER';
export var REQUEST = 'REQUEST';
export var SUCCESS = 'SUCCESS';
export var FAILURE = 'FAILURE';
export var FULFILL = 'FULFILL';
export default [TRIGGER, REQUEST, SUCCESS, FAILURE, FULFILL];


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-saga-routines/es/routineStages.js
// module id = 715
// module chunks = 0